import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { hd } from '.';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(private http: HttpClient) {}

  // Returns an observable
  upload<T>(config: hd.IUploadConfig): Observable<any> {
    const file = config.data.file as File;

    // Create form data to store file data
    const formData = new FormData();
    formData.append('file', file, file.name);

    // Make request with formData as body encoded as form-data
    return this.http.post<T>(config.url, formData, { headers: { enctype: 'multipart/form-data' } });
  }
}
